// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"690521a5","993":"61de02c6"}[chunkId] + ".chunk.css";
};